<template>
    <aside class="d-flex flex-column overflow-hidden" :class="[{'collapsed':!isHoveringMenu}, environment]" @mouseenter="mouseenter" @mouseleave="mouseleave">
    <!-- <aside class="d-flex flex-column" @mouseenter="mouseenter" @mouseleave="mouseleave"> -->
        <nav role="navigation" class="flexGrow1">
            <router-link class="logo" :to="{ name: 'dashboard'}">
                <div class="logoCanvas">
                    <img class="logoBig" src="../../assets/images/logo.svg" alt="Pluralo">
                </div>
                <img class="logoSmall" src="/static/images/common/logo_small_red_white.svg" alt="Pluralo">
            </router-link>
            <ul>

                <li v-for="link in linksNew" v-if="showThisLink(link)" class="position-relative">
                    <router-link exact active-class="active" :to="{ name: link.linkTo }">
                        <span class="selection"></span>
                        <span class="fs-larger position-relative">
                            <i :class="link.icon">
                            </i>
                            <span class="newItemLabel fs-smallest bg-color-1" v-if="showNewLabel(link)">New</span>
                        </span>
                        <span class="label">{{ link.label }}</span>
                    </router-link>
                </li>
            </ul>
        </nav>
        <div class="bottomInfoBig darker p-2">
            <span @click="reloadApp" class="pointer"><i class="ico ico-reshedule fs-normal"></i> {{version}} Beta - </span>
            <span class="fs-smaller darker" @click="testPerformance">{{getUserAccessType.label}}</span>
        </div>
        <div class="bottomInfoSmall darker p-2 text-center">
            <span>{{version}}</span>
        </div>

    </aside>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    export default {
        data: function() {
            return {
                testeMyAccess: 1,
                isHoveringMenu: false,
                linksNew: [
                    {
                        label: 'Home',
                        linkTo: 'dashboard',
                        icon: 'fas fa-home',
                        allowedToAccess: ['admin','basic','restricted','supervisor']
                    },
                    {
                        label: 'Calendar',
                        linkTo: 'calendar',
                        icon: 'far fa-calendar-alt',
                        allowedToAccess: ['admin','basic','restricted','supervisor', 'viewer']
                    },
                    {
                        label: 'Reservations',
                        linkTo: 'reservations',
                        icon: 'fas fa-clipboard-check',
                        allowedToAccess: ['admin','basic','restricted','supervisor']
                    },
                    {
                        label: 'People',
                        linkTo: 'people',
                        icon: 'fas fa-users',
                        allowedToAccess: ['admin','supervisor']
                    },
                    {
                        label: 'My inventory',
                        linkTo: 'inventory',
                        icon: 'fas fa-shapes',
                        allowedToAccess: ['admin']
                    },
                    {
                        label: 'Invoices',
                        linkTo: 'invoices',
                        icon: 'fas fa-file-invoice-dollar',
                        allowedToAccess: ['admin','supervisor'],
                        enabled: this.showInvoiceOption,
                    },
                    {
                        label: 'Reports',
                        linkTo: 'reports',
                        icon: 'far fa-chart-bar',
                        allowedToAccess: ['admin','supervisor']
                    },
                    {
                        label: 'Promocodes',
                        linkTo: 'promocodes',
                        icon: 'fas fa-bullhorn',
                        allowedToAccess: ['admin','supervisor'],
                        newLabel: {
                            until: '2019-04-30'
                        }
                    },
                    {
                        label: 'Schedule Tasks',
                        linkTo: 'scheduleTasks',
                        icon: 'fas fa-business-time',
                        allowedToAccess: ['admin','supervisor'],
                        newLabel: {
                            until: '2020-04-30'
                        }
                    },
                    {
                        label: 'Settings',
                        linkTo: 'settings',
                        icon: 'fas fa-cog',
                        allowedToAccess: ['admin'],
                    },
                ],
            }
        },
        computed:{
            ...mapGetters([
                'account',
                'getUserAccessType',
                'getShowInvoiceOption'
            ]),
            version: function(){
                return process.env.CURRENT_VERSION
            },
            environment: function(){
                return process.env.NODE_ENV
            },
        },
        created: function() {
        },
        methods: {
            ...mapActions([
                'checkAppVersion',
            ]),
            reloadApp: function() {
                location.reload(true);
            },
            showNewLabel: function (item) {
                if(!item.newLabel){
                    return false
                }

                return moment().isBefore(item.newLabel.until);
            },
            showThisLink: function (link) {
                let doIHavePermissions = this.accessPermissionFilter(link.allowedToAccess)
                if(!link.enabled){
                    return doIHavePermissions
                } else {
                    return doIHavePermissions && link.enabled()
                }

            },
            testPerformance: function(){
                this.checkAppVersion()
                axios.get('/ping/service', {
                    params: {

                    }
                }).then(response => {
                    console.log(response.data);
                })
            },
            mouseenter: function (e) {
                this.isHoveringMenu = true
                if(document.querySelector('#intercom-container .intercom-app .intercom-launcher-frame')){
                    document.querySelector('#intercom-container .intercom-app .intercom-launcher-frame').classList.add("big");
                }
            },
            mouseleave: function () {
                this.isHoveringMenu = false
                if(document.querySelector('#intercom-container .intercom-app .intercom-launcher-frame')){
                    document.querySelector('#intercom-container .intercom-app .intercom-launcher-frame').classList.remove("big");
                }
            },
            showInvoiceOption: function () {
                return this.getShowInvoiceOption? this.getShowInvoiceOption : false
            },
        }
    }
</script>
<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';
@import '~@/assets/scss/_typography.scss';

aside {
    transition: all 300ms ease-in-out;
    color: $lightest;
    background: $darkest;
    // flex: 0 0 11rem;
    width: 12rem;

    &.stage{
        background: $red;
    }

    &.development{
        background: $blue;
    }

    nav {
        transition: all 300ms ease-in-out;
        width: 11rem;

        a{
            height: 60px;
        }

        > .logo {
            display: block;
            margin: 3.5rem 0 1rem;
            text-align: center;
            transition: none;

            .logoBig{
                height: 29px;
            }

            .logoSmall{
                display: none;
            }
        }

        > ul {
            > li {
                display: block;
                padding: 0.75rem 0;

                > a {

                    color: $lightest;

                    i{
                        width: 20px;
                        text-align: center;
                    }

                    .selection {
                        transition: all 300ms ease-in-out;
                        display: inline-block;
                        margin-right: 1.2rem;
                    }

                    &.active {
                        @extend .bold;
                        padding-left: 0;

                        .selection {
                            display: inline-block;
                            vertical-align: middle;
                            width: 0.35rem;
                            height: 1.75rem;
                            border-top-right-radius: 5rem;
                            border-bottom-right-radius: 5rem;
                            background-color: $brand;
                            margin-right: calc(1.2rem - 6px);
                        }
                    }

                    &:active, &:focus {
                        color: $lightest;
                        text-decoration: none;
                    }
                }
            }
        }
    }

    .bottomInfoSmall{
        display: none;
    }
}


aside.collapsed {

    // flex: 0 0 4.5rem;
    width: 4.7rem;

    nav {

        // width: 4.5rem;

        .logo {
            width: 4.5rem;

            .logoCanvas{

                width: 48px;
                overflow: hidden;
                padding-left: 4px;
                display: inline-block;

                .logoBig{
                    // display: none;
                    height: 41px;
                }

            }

            // .logoSmall{
            //     display: inline-block;
            //     width: 30px;
            // }
        }

        ul {

            li {
                a{
                    i {

                    }

                    .selection {
                        margin-right: 1.4rem;
                    }

                    &.active{
                        .selection {
                            margin-right: calc(1.4rem - 6px);
                        }
                    }

                    .label {
                        display: none
                    }
                }
            }
        }
    }

    .bottomInfoBig{
        display: none;
    }

    .bottomInfoSmall{
        display: inline-block;
    }
}


.newItemLabel{
    position: absolute;
    bottom: -15px;
    left: -5px;
    padding: 2px 4px;
    border-radius: 5px;
    line-height: 0.9em;
}



</style>
<!--
<style media="screen" lang="scss">
    #intercom-container .intercom-app .intercom-launcher-frame{
        transition: all 300ms ease-in-out;
        &.small{
            left: 5px !important;
        }
    }
</style> -->



// WEBPACK FOOTER //
// Sidebar.vue?1042aaaa